var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "navigation",
      class: { "navigation--show-mobile": _vm.isShowingOnMobile },
    },
    [
      _c(
        "button",
        {
          staticClass: "navigation__close-button button button--transparent",
          on: { click: _vm.hideMobileMenu },
        },
        [
          _c("img", {
            attrs: {
              src: _vm.asset.image("icons/close_grey.svg"),
              alt: "Navigation Close",
            },
          }),
        ]
      ),
      _vm._v(" "),
      !_vm.state.isLoading
        ? [
            _c(
              "div",
              { staticClass: "navigation__main-menu" },
              [
                _c(
                  "a",
                  {
                    staticClass: "navigation__logo navigation__logo__desktop",
                    class: {
                      "navigation__logo--no-uplink":
                        _vm.state.navigation.uplink != null,
                    },
                    attrs: { href: _vm.getters.dashboardUrl },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.asset.image("brand/logo-xl.svg"),
                        alt: "g-portal-logo",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _vm.state.navigation.uplink == null
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "navigation__main-menu__btn button button--quickorder",
                        attrs: { href: _vm.getters.gameserverIndexUrl },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.i18n.t("general:navigation.rent_server")
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  : _c(
                      "ul",
                      {
                        staticClass:
                          "navigation__menu__group navigation__menu__group--back",
                      },
                      [
                        _c("li", { staticClass: "navigation__menu__item" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "navigation__menu__link navigation__menu__label",
                              attrs: {
                                href: _vm.state.navigation.uplink.data.url,
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "icon far fa-arrow-alt-circle-left",
                              }),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.translateLabel(
                                      _vm.state.navigation.uplink
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                _vm._v(" "),
                _vm._l(
                  _vm.state.navigation.items,
                  function (navGroupItem, index) {
                    return _c("side-navigation-group", {
                      key: index,
                      attrs: {
                        "nav-group-item": navGroupItem,
                        "hide-group-label":
                          _vm.state.navigation.items.length === 1,
                      },
                    })
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("side-navigation-quick-menu", {
              attrs: { "data-quick-menu": "" },
              on: { openSearch: _vm.openSearch },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "mounting-portal",
        { attrs: { "mount-to": "#application-backdrop", append: "" } },
        [
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.isShowingBackdrop
              ? _c("div", {
                  staticClass: "navigation__backdrop",
                  on: { click: _vm.hideMobileMenu },
                })
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }